[
  {
    "code" : "C512",
    "description" : "SDE - Vergunning voor het gebruik van de vereenvoudigde aangifte (Gedelegeerde Verordening (EU) 2015/2446, bijlage A, kolom 7a)"
  },
  {
    "code" : "C552",
    "description" : "T2LSM - Bewijs van de status van voor San Marino bestemde goederen met toepassing van artikel 2 van Besluit nr. 4/92 van het Samenwerkingscomité EEG-San Marino van 22 december 1992"
  },
  {
    "code" : "C605",
    "description" : "Informatieblad INF3"
  },
  {
    "code" : "C612",
    "description" : "Aangifte tot plaatsing onder de regeling communautair douanevervoer; T2F"
  },
  {
    "code" : "C620",
    "description" : "Document T2LF"
  },
  {
    "code" : "N235",
    "description" : "Containerlijst"
  },
  {
    "code" : "N270",
    "description" : "Ladinglijst"
  },
  {
    "code" : "N271",
    "description" : "Paklijst"
  },
  {
    "code" : "N325",
    "description" : "Pro-forma-factuur"
  },
  {
    "code" : "N337",
    "description" : "Aangifte tot tijdelijke opslag"
  },
  {
    "code" : "N355",
    "description" : "Summiere aangifte bij binnenkomst"
  },
  {
    "code" : "N380",
    "description" : "Handelsfactuur"
  },
  {
    "code" : "N703",
    "description" : "House-vrachtbrief"
  },
  {
    "code" : "N704",
    "description" : "Master-cognossement"
  },
  {
    "code" : "N705",
    "description" : "Cognossement"
  },
  {
    "code" : "N714",
    "description" : "House-cognossement"
  },
  {
    "code" : "N720",
    "description" : "Vrachtbrief CIM"
  },
  {
    "code" : "N722",
    "description" : "Road list - SMGS"
  },
  {
    "code" : "N730",
    "description" : "Vrachtbrief wegvervoer"
  },
  {
    "code" : "N740",
    "description" : "Luchtvrachtbrief"
  },
  {
    "code" : "N741",
    "description" : "Master-luchtvrachtbrief"
  },
  {
    "code" : "N750",
    "description" : "Vervoer door middel van postzendingen (postcolli daaronder begrepen)"
  },
  {
    "code" : "N760",
    "description" : "Document voor multimodaal/gecombineerd vervoer"
  },
  {
    "code" : "N785",
    "description" : "Goederenmanifest"
  },
  {
    "code" : "N787",
    "description" : "Borderel (goederenlaadlijst)"
  },
  {
    "code" : "N820",
    "description" : "Aangifte voor douanevervoer, T"
  },
  {
    "code" : "N821",
    "description" : "Aangifte tot plaatsing onder de regeling extern communautair douanevervoer/gemeenschappelijk douanevervoer, T1"
  },
  {
    "code" : "N822",
    "description" : "Aangifte tot plaatsing onder de regeling intern communautair douanevervoer; T2"
  },
  {
    "code" : "N825",
    "description" : "Document T2L"
  },
  {
    "code" : "N952",
    "description" : "Carnet TIR"
  },
  {
    "code" : "N955",
    "description" : "Carnet ATA"
  },
  {
    "code" : "NCLE",
    "description" : "Kenmerk/datum van inschrijving in de administratie van de aangever"
  },
  {
    "code" : "NMNS",
    "description" : "Goederenmanifest - vereenvoudigde procedure"
  },
  {
    "code" : "NMRN",
    "description" : "Aangifte/kennisgeving MRN"
  }
]
